import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/proto-ui")({
  beforeLoad: () => {
    throw redirect({ to: "/proto-for-admin" });
  },
});
